"use strict";

import React from "react";
import ReactDOM from "react-dom";
import RaceGraphics from "../../src/features/event";

document.addEventListener("DOMContentLoaded", () => {
  const expandBtn = document.querySelector(".fullscreen");
  const fullwidthContainer = document.querySelector(".course_container.with_route");
  const closeBtn = document.querySelector(".btn-close");
  const navContainer = document.querySelector(".show-on-fullscreen-only");

  if (expandBtn) {
    expandBtn.addEventListener("click", function (e) {
      handleClick(e, this);
    });
  }

  document.addEventListener("fullscreenchange", fullscreenchanged);

  function handleClick(e, node) {
    makeFullscreen(fullwidthContainer);
  }

  // When exit key is pressed
  function fullscreenchanged(event) {
    if (document.fullscreen) {
    } else {
      fullwidthContainer.classList.remove("on");
      expandBtn.classList.add("d-flex");
      expandBtn.classList.remove("d-none");
      closeBtn.classList.remove("d-flex");
      closeBtn.classList.add("d-none");
    }
  }

  function makeFullscreen(elem) {
    elem.classList.add("on");
    if (document.fullscreenEnabled) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen().then(
          () => {},
          () => {
            console.warn("no fullscreen");
          }
        );
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    } else {
      document.querySelector(".error").innerHTML = "Your browser is not supported";
    }

    elem.querySelector(".fullscreen").classList.add("d-none");
    navContainer.classList.add("d-flex");
    navContainer.classList.remove("d-none");
    closeBtn.classList.remove("d-none");
    closeBtn.classList.add("d-flex");
    closeBtn.addEventListener("click", function (e) {
      exitFullscreen();
      closeBtn.classList.remove("d-flex");
      closeBtn.classList.add("d-none");
    });
  }

  function exitFullscreen() {
    fullwidthContainer.classList.remove("on");
    navContainer.classList.add("d-none");
    navContainer.classList.remove("d-flex");
    expandBtn.classList.add("d-flex");
    expandBtn.classList.remove("d-none");
    document.exitFullscreen();
  }

  const container = document.querySelector(".route-graph");
  if (container) {
    let data = JSON.parse(container.getAttribute("data"));
    let routeId = container.getAttribute("routeId");
    ReactDOM.render(<RaceGraphics data={data} id={routeId} />, container);
  }
});
